import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-592" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-593" data-mp="3ggk8mvu5ve02">
        {/* Column 1 */}
        <div className="lg:pr-8" data-id="element-594" data-mp="36pfutzg81z6t">
          <img src="https://cdn.magicpatterns.com/uploads/pa3Fk96C6qU6AFqdF9EfnU/ChatGPT_Image_Aug_25,_2026,_10_57_05_AMff.png" alt="SyNeural — Creating an Intelligent Web" className="h-10 w-auto mb-5 brightness-0 invert" data-id="element-595" data-mp="36qhhl16loa4d" />
          <p className="text-sm leading-relaxed" data-id="element-596" data-mp="3lem0o69kenno">
            Building better judgment for a more capable society.
          </p>
        </div>

        {/* Column 2 */}
        <div data-id="element-597" data-mp="3qfjj8jyhljpp">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-598" data-mp="3qf9nsguoakcm">
            Platform
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-599" data-mp="2eyjq5m4bf0um">
            <li data-id="element-600" data-mp="2ew6zmkkhri5y">
              <a href="#cji" className="hover:text-white transition-colors" data-id="element-601" data-mp="3l9k5dbpy7lcr">
                CJI
              </a>
            </li>
            <li data-id="element-602" data-mp="3gb8wb37h9evl">
              <a href="#ncji" className="hover:text-white transition-colors" data-id="element-603" data-mp="3gbr0cm0dsxe2">
                NCJI
              </a>
            </li>
            <li data-id="element-604" data-mp="3v5n74ggw1hz6">
              <a href="#solutions" className="hover:text-white transition-colors" data-id="element-605" data-mp="3q8n125k1gf82">
                Solutions
              </a>
            </li>
            <li data-id="element-606" data-mp="80nu4lf3sudx">
              <a href="#home" className="hover:text-white transition-colors" data-id="element-607" data-mp="34739jgis1x5">
                Platform Overview
              </a>
            </li>
          </ul>
        </div>

        {/* Column 3 */}
        <div data-id="element-608" data-mp="cu0hks81qv53">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-609" data-mp="ctgwx3r0hsnd">
            Applications
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-610" data-mp="qtroya425da4">
            <li data-id="element-611" data-mp="ms6h536drp6s">
              <a href="#education" className="hover:text-white transition-colors" data-id="element-612" data-mp="mspppta55185">
                Education
              </a>
            </li>
            <li data-id="element-613" data-mp="yto9s3rqyhxw">
              <a href="#employers" className="hover:text-white transition-colors" data-id="element-614" data-mp="yv93jr68lwup">
                Employers
              </a>
            </li>
            <li data-id="element-615" data-mp="18k92xboniu9f">
              <a href="#civil-society" className="hover:text-white transition-colors" data-id="element-616" data-mp="18ksn6z1rxuqm">
                Civil Society
              </a>
            </li>
            <li data-id="element-617" data-mp="1hje1gi07qnll">
              <a href="#government" className="hover:text-white transition-colors" data-id="element-618" data-mp="1hiul35q7o79o">
                Government
              </a>
            </li>
            <li data-id="element-619" data-mp="1rid3hhqh3kzm">
              <a href="#leadership" className="hover:text-white transition-colors" data-id="element-620" data-mp="1rgsgqeaeh6cb">
                Leadership
              </a>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div data-id="element-621" data-mp="2afdidco5p8os">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-622" data-mp="2ag5csk60p0dh">
            Company
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-623" data-mp="25mamgxvwpn5f">
            <li data-id="element-624" data-mp="21m0i1pnrj4so">
              <a href="#about" className="hover:text-white transition-colors" data-id="element-625" data-mp="21nv10yfh4mu4">
                About
              </a>
            </li>
            <li data-id="element-626" data-mp="1wlma07m5vuun">
              <a href="#research" className="hover:text-white transition-colors" data-id="element-627" data-mp="2tdzjgrjoazsp">
                Research
              </a>
            </li>
            <li data-id="element-628" data-mp="2pajqq6aq5jla">
              <a href="#partnerships" className="hover:text-white transition-colors" data-id="element-629" data-mp="2kd1dw4tl6k80">
                Partnerships
              </a>
            </li>
            <li data-id="element-630" data-mp="18y4kkiqdd8uu">
              <a href="#contact" className="hover:text-white transition-colors" data-id="element-631" data-mp="18ynxtm52r92j">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-632" data-mp="2rvr9bkiumyhz">
        <p data-id="element-633" data-mp="2wn98q4584r0u">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-634" data-mp="2ivufz5lilbgl">
          <a href="#privacy" className="hover:text-white transition-colors" data-id="element-635" data-mp="2iwvzzzkid8ag">
            Privacy Policy
          </a>
          <a href="#terms" className="hover:text-white transition-colors" data-id="element-636" data-mp="2nrrst1xkjzom">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}